import axios from 'axios'

import {
	PROJECT_GOT_DATA,
	PROJECT_SET_SLUG,
	PROJECT_STATUSES_SAVED,
	SUBSCRIBER_TOGGLED
} from './types'

import { API_URL } from '../api'

import copy from 'fast-copy'

export function getProject(slug, callback) {
	return dispatch => {
		dispatch({
			type: PROJECT_SET_SLUG,
			payload: slug
		})

		axios.get(`${API_URL}/projects?slug=${slug}`)
			.then(response => {
				let project = response.data

				dispatch({
					type: PROJECT_GOT_DATA,
					payload: project,
				})

				callback(project)
			}).catch(error => {
				callback(null, error)
				console.log(error)
			})
	}
}

export const getProjectFiles = (slug, callback) => {
	return dispatch => {
		axios.get(`${API_URL}/projects/files?slug=${slug}`)
			.then(response => {
				const project = response.data
				project.hasFetchedFiles = true

				dispatch({
					type: PROJECT_GOT_DATA,
					payload: project
				})
			}).catch(error => {
				console.log(error)
			})
	}
}

export const getPulseData = (id, userId = null, callback) => {
	return dispatch => {
		console.log(userId)

		axios.get(`${API_URL}/projects/pulseData/${id}${ userId ? '?userId='+userId  : ''}`)
			.then(response => {
				callback({
					userIds: response.data.pulse_user_ids,
					data: response.data.pulse_data
				})	
			}).catch(error => {
				console.log(error)
				callback(null)
			})
	}
}

export function updateMilestone(data, type) {
	return dispatch => {
		axios.post(API_URL + '/updateItem', { data, type }).then(response => {
			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data,
				entityType: 'milestone',
			})
		}).catch(error => {
			console.log(error)
		})
	}
}

export function updateMilestoneOrder(milestones) {
	return dispatch => {
		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: milestones,
			entityType: 'milestone',
			isArray: true
		})

		axios.post(API_URL + '/project/updateMilestoneOrder', { milestones }).catch(error => {
			console.log(error)
		})
	}
}

export function addOrRemoveSubscriber(user, project) {
	return function (dispatch) {
		axios.post(API_URL + '/project/addOrRemoveSubscriber', { user, project }).catch(error => {
			console.log(error)
		})

		dispatch({
			type: SUBSCRIBER_TOGGLED,
			payload: {
				user: user,
				project: project
			}
		})
	}
}

export function removeProjectSlug() {
	return dispatch => {
		dispatch({
			type: PROJECT_SET_SLUG,
			payload: null
		})
	}
}

export function saveColumnData(projectId, columns, callback) {
	return dispatch => {
		axios.post(`${ API_URL }/project/${ projectId }/saveColumnData`, { columns }).then(response => {
			callback(true)

			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: response.data,
				entityType: 'project'
			})
		}).catch(error => {
			console.log(error)
		})
	}
}

export function saveTaskStatuses(projectId, statusesData, type, column) {
	const updatedStatusData = statusesData

	return dispatch => {
		axios.post(API_URL + '/project/saveStatuses', { projectId, statuses: updatedStatusData, column })

		dispatch({
			type: PROJECT_STATUSES_SAVED,
			payload: {
				projectId,
				updatedStatusData,
				column
			}
		})
	}
}

export function toggleCollapseMilestone(user, operationOrMilestoneId, milestones = null) {
	const newUserData = copy(user)
	let collapsedMilestones = newUserData.collapsed_milestones ? newUserData.collapsed_milestones : []

	switch (operationOrMilestoneId) {
		case 'expand':
			collapsedMilestones = []
			break
		case 'collapse':
			collapsedMilestones = milestones
			break
		default:
			const indexIfExists = collapsedMilestones.findIndex(loopedMilestoneId => {
				return operationOrMilestoneId == loopedMilestoneId
			})

			if (indexIfExists < 0) {
				collapsedMilestones.push(operationOrMilestoneId)
			} else {
				collapsedMilestones.splice(indexIfExists, 1)
			}
			break
	}

	newUserData.collapsed_milestones = collapsedMilestones

	return dispatch => {
		axios.post(API_URL + '/user/toggleCollapsedMilestones', { collapsedMilestones })
			.catch(error => {
				console.log(error)
			})

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: newUserData,
			entityType: 'user'
		})
	}

}

export const getArchivedProjects = callback => {
	return dispatch => {
		axios.get(API_URL + '/project/getArchivedProjects')
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'account',
				})

				callback()
			})
			.catch(error => {
				console.log(error)
			})
	}
}

export function getArchivedData(project, callback) {
	return dispatch => {
		axios.get(API_URL + '/project/getArchived?id=' + project.id)
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'project',
				})

				callback()
			}).catch(error => {
				console.log(error)
			})
	}
}

export const restoreProject = (project, forcedFolder) => {
	return dispatch => {
		const restoredProject = {
			...project
		}

		restoredProject.deleted_at = null

		if(forcedFolder){
			const clonedForcedFolder = copy(forcedFolder)

			clonedForcedFolder.projects.push(project)

			dispatch({
				type: 'ENTITY_ADDED_OR_UPDATED',
				payload: clonedForcedFolder,
				entityType: 'folder',
			})

			restoredProject.folder = forcedFolder
			restoredProject.folder_id = forcedFolder.id
		}else{
			restoredProject.folder = {
				id: restoredProject.folder_id,
				projects: [project]
			}
		}

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: restoredProject,
			entityType: 'project',		})

		axios.post(API_URL + '/project/restore/' + project.id)
	}
}

export const saveProjectUpdate = (data, callback) => {
	return dispatch => {
		axios.post(API_URL + '/project/addUpdate', data)
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'progressUpdate',
				})

				callback()
			})
			.catch(error => {
				console.log(error)
			})
	}
}

export const getProgressUpdates = (projectId, callback) => {
	return dispatch => {
		axios.get(API_URL+'/project/getUpdates/'+projectId)
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'project',
				})

				callback()
			})
			.catch(error => {
				console.log(error)
			})
	}
}

export const getMeetings = (projectId, callback) => {
	return dispatch => {
		axios.get(API_URL+'/project/'+projectId+'/getMeetings')
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'project',
				})

				callback()
			}).catch(error => {
				console.log(error)
			})
	}
}

export const addMeeting = (projectId, callback) => {
	return dispatch => {
		axios.post(API_URL+'/project/'+projectId+'/createMeeting')
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data.milestone,
					entityType: 'milestone',
				})

				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data.meeting,
					entityType: 'meeting',
				})
			})
			.catch(error => {
				console.log(error)
			})

	}
}

export const saveMeeting = (meeting, callback) => {
	return dispatch => {
		axios.post(API_URL+'/project/saveMeeting', { meeting })
			.then(response => {
				dispatch({
					type: 'ENTITY_ADDED_OR_UPDATED',
					payload: response.data,
					entityType: 'meeting',
				})

				callback()
			}).catch(error => {
				console.log(error)
				callback()
			})
	}
}

export const generateGantt = (ganttData, project) => {
	const earliestDate = ganttData.earliestMoment.format('YYYY-MM-DD')

	const formattedGanttData = {
		earliestDate,
		totalDays: ganttData.totalDateRange,
		milestones: ganttData.rowData
	}

	return dispatch => {
		axios.post(API_URL+'/project/'+project.id+'/generateGantt', { formattedGanttData })
			.then(response => {
				const anchor = document.createElement('a')
				anchor.href = API_URL+'/project/'+project.id+'/getGantt'

				document.body.appendChild(anchor)
				anchor.click()
				anchor.remove()
			}).catch(error => {
				console.log(error)
			})
	}
}

export const favouriteProject = (project, user) => {
	return dispatch => {
		const userFavorites = user.favourite_projects ? [...user.favourite_projects] : []

		const indexIfExists = userFavorites.indexOf(project.id)

		if(indexIfExists !== -1){
			userFavorites.splice(indexIfExists, 1)
		}else{
			userFavorites.push(project.id)
		}

		dispatch({
			type: 'ENTITY_ADDED_OR_UPDATED',
			payload: {
				...user,
				favourite_projects: userFavorites
			},
			entityType: 'user',
		})

		axios.post(API_URL+'/user/favouriteProject', { project })
	}
}